export default __webpack_public_path__ + "6b109fecbc7563467e364a228c5106f0.ttf";